import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ProponenteService } from 'administrativo-lib';
import { Favorecido, FuncaoService, Licitacao, Login, Proponente } from 'eddydata-lib';
import { ConfirmationService } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';

declare var $: any;

@Component({
  selector: 'app-proponente',
  templateUrl: './proponente.component.html'
})
export class ProponenteComponent implements OnInit, OnDestroy {

  public itemAtual: Proponente;

  @Input() entidade: Licitacao;
  @Input() login: Login;
  @Input() edicao: boolean = false;

  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    public funcaoService: FuncaoService,
    protected confirmationService: ConfirmationService,
    protected proponenteService: ProponenteService,
  ) { }

  ngOnInit(): void {

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public adicionar() {
    if (!this.edicao) return;
    this.itemAtual = new Proponente();
    this.itemAtual.favorecido = new Favorecido();
    this.itemAtual.situacao = 'HABILITADO';

    $('#dialogFavorecidoCadastro').modal('show');
  }

  public salvar(item: Proponente) {
    if (!this.edicao) return;
    if (item) {
      if (!this.entidade.proponentes) {
        this.entidade.proponentes = [];
      }
      this.atualizarOrdem();

      const itm = this.entidade.proponentes.find((i) => i.favorecido.cpf_cnpj === item.favorecido.cpf_cnpj)
      if (itm) {
        itm.favorecido = item.favorecido;
        itm.epp_me = item.epp_me;
        itm.situacao = item.situacao;
        itm.motivo = item.motivo;
      } else {
        if (this.entidade.proponentes.length === 0) {
          item.ordem = 1;
        } else {
          item.ordem = (this.entidade.proponentes[this.entidade.proponentes.length - 1].ordem) + 1;
        }
        this.entidade.proponentes.push(item);
        this.ordenarItens();
      }
    }
  }

  public remover(item: Proponente, index: number) {
    if (!this.edicao) return;
    if (item.id) {
      this.confirmationService.confirm({
        message: 'Deseja realmente remover o proponente? Todas as propostas vinculadas a este proponente serão removidas.',
        header: 'Exclusão',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Confirmar',
        rejectLabel: 'Cancelar',
        accept: () => {
          this.proponenteService.remover(item.id).pipe(takeUntil(this.unsubscribe))
            .subscribe((res) => {
              toastr.info('Registro removido com sucesso!', 'Exclusão');
              this.entidade.proponentes.splice(index, 1);
              this.atualizarOrdem();
            }, (err) => toastr.error(err.error.payload));
        }
      });
    } else {
      this.entidade.proponentes.splice(index, 1);
      this.atualizarOrdem();
    }
  }

  private ordenarItens() {
    this.entidade.proponentes.sort((a, b) => { return a.ordem - b.ordem });
  }

  private atualizarOrdem() {
    if (!this.edicao) return;
    this.ordenarItens();
    let ordem = 0;
    this.entidade.proponentes.forEach((m) => {
      m.ordem = ++ordem;
    })
  }
}
